
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.373 7.709a5.533 5.533 0 11-11.065 0 5.533 5.533 0 0111.065 0z","stroke":"#748190","stroke-width":".571"}}),_c('path',{attrs:{"d":"M6.43 4.279a2.732 2.732 0 11-5.464 0 2.732 2.732 0 015.464 0zM16.716 4.279a2.732 2.732 0 11-5.464 0 2.732 2.732 0 015.464 0zM11.572 13.422a2.732 2.732 0 11-5.463 0 2.732 2.732 0 015.463 0z","fill":"#748190","stroke":"#748190","stroke-width":".25"}})])
          )
        }
      }
    